import { config } from "@/config";
import JSEncrypt from "jsencrypt";

export function formatTest(pass) {
  if (pass.length < 8 || pass.length > 16) {
    return {err:true,msg:'密码长度为8~16位'};
  }

  var patternNum = /\d+/; //数字
  var patternLetterUp = /[a-zA-Z]+/; // 字母
  var patternLetterLow = /[a-z]+/; // 字母
  var patternFuhao = /[!@%^*、‘+=-\\.]+/; // 特殊符号
  var patternhanzi = /[\u4e00-\u9fa5]+/; // 汉字
  var patternFuhaoNo = /[';<>$&#()\\s]+/; // 不含字符
  var patternFour = /([\s\S])(\1){3,}/; //不可连续四位相同
  if (
    !patternNum.test(pass) ||
    !patternLetterUp.test(pass)
    // !patternLetterLow.test(pass) ||
    // !patternFuhao.test(pass)
  ) {
    return { err: true, msg: "密码需包含数字、字母" };
  }
  // if (patternFour.test(pass)) {
  //   return { err: true, msg: "密码含有过多连续字符" };
  // }
  // if (patternFuhaoNo.test(pass)) {
  //   return { err: true, msg: "密码含有非法字符" };
  // }
  if (patternhanzi.test(pass)) {
    return { err: true, msg: "密码不可使用汉字" };
  }

  return { err: false, msg: "" };
}

export function RSA(pass) {
  var encrypt = new JSEncrypt();
  encrypt.setPublicKey(config.RsaPublicKey);
  return encrypt.encrypt(pass);
}



// WEBPACK FOOTER //
// ./src/utils/password.js